import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["subtotal", "taxRate", "salesRate", "total"]

  connect() {
    console.log("InvoiceFormController connected")
    // Only auto-calculate if this appears to be a new record (empty totals)
    if (this.isNewRecord()) {
      this.calculate()
    }
  }

  isNewRecord() {
    // Check if the subtotal and total fields are empty (indicating a new record)
    const subtotalEmpty = !this.hasSubtotalTarget || !this.subtotalTarget.value || this.subtotalTarget.value.trim() === '';
    const totalEmpty = !this.hasTotalTarget || !this.totalTarget.value || this.totalTarget.value.trim() === '';
    return subtotalEmpty && totalEmpty;
  }

  calculate() {
    const items = this.element.querySelectorAll('[data-invoice-item-target="item"]');
    let subtotal = 0;
    items.forEach(item => {
      const quantity = parseFloat(item.querySelector('[data-invoice-item-target="quantity"]').value) || 0;
      const price = parseFloat(item.querySelector('[data-invoice-item-target="price"]').value) || 0;
      subtotal += quantity * price;
    });

    if (this.hasSubtotalTarget && this.subtotalTarget.dataset.manualEdit !== "true") {
      this.subtotalTarget.value = subtotal.toFixed(2);
    }
    
    const taxRate = this.hasTaxRateTarget ? (parseFloat(this.taxRateTarget.value) || 0) : 0;
    const salesRate = this.hasTaxRateTarget ? (taxRate * this.subtotalTarget.value) / 100.00 : 0;

    if (this.hasSalesRateTarget && this.salesRateTarget.dataset.manualEdit !== "true") {
      this.salesRateTarget.value = salesRate.toFixed(2);
    }
    
    const currentSubtotal = this.hasSubtotalTarget ? (parseFloat(this.subtotalTarget.value) || 0) : subtotal;
    
    if (this.hasTotalTarget && this.totalTarget.dataset.manualEdit !== "true") {
      const total = currentSubtotal + salesRate;
      this.totalTarget.value = total.toFixed(2);
    }
  }

  lock(event) {
    event.currentTarget.dataset.manualEdit = "true";
  }

  unlock(event) {
    const targetName = event.params.target;
    // Map target names to proper camelCase
    const targetMap = {
      'subtotal': 'subtotalTarget',
      'total': 'totalTarget',
      'taxRate': 'taxRateTarget',
      'salesRate': 'salesRateTarget'
    };
    
    const targetProperty = targetMap[targetName];
    if (targetProperty && this[targetProperty]) {
      this[targetProperty].dataset.manualEdit = "false";
      this.calculate();
    }
  }
} 
